var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDriver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1511 5.89778C17.9733 5.37333 17.4756 5 16.8889 5H7.11111C6.52444 5 6.03556 5.37333 5.84889 5.89778L4.09778 10.9378C4.03556 11.1244 4 11.32 4 11.5244V17.8889C4 18.6267 4.59556 19.2222 5.33333 19.2222C6.07111 19.2222 6.66667 18.6267 6.66667 17.8889V17.4444H17.3333V17.8889C17.3333 18.6178 17.9289 19.2222 18.6667 19.2222C19.3956 19.2222 20 18.6267 20 17.8889V11.5244C20 11.3289 19.9644 11.1244 19.9022 10.9378L18.1511 5.89778ZM7.11111 14.7778C6.37333 14.7778 5.77778 14.1822 5.77778 13.4444C5.77778 12.7067 6.37333 12.1111 7.11111 12.1111C7.84889 12.1111 8.44444 12.7067 8.44444 13.4444C8.44444 14.1822 7.84889 14.7778 7.11111 14.7778ZM16.8889 14.7778C16.1511 14.7778 15.5556 14.1822 15.5556 13.4444C15.5556 12.7067 16.1511 12.1111 16.8889 12.1111C17.6267 12.1111 18.2222 12.7067 18.2222 13.4444C18.2222 14.1822 17.6267 14.7778 16.8889 14.7778ZM5.77778 10.3333L6.90667 6.93778C7.03111 6.58222 7.36889 6.33333 7.75111 6.33333H16.2489C16.6311 6.33333 16.9689 6.58222 17.0933 6.93778L18.2222 10.3333H5.77778Z",
    fill: "#868B90"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriver);
export default __webpack_public_path__ + "static/media/Driver.f3c6e14e.svg";
export { ForwardRef as ReactComponent };